"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-valbelluna": {
    "e6e3e219": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "skipSearch": false
    }],
    "boschi": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a6c22fc": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "skipSearch": false
    }],
    "cesana": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "687279ba": [{
      "hkey": "4f3e66f8",
      "slug": "villapiana-ronchena",
      "name": "Villapiana-Ronchena",
      "primary": true,
      "skipSearch": false
    }],
    "ronchena": [{
      "hkey": "4f3e66f8",
      "slug": "villapiana-ronchena",
      "name": "Villapiana-Ronchena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "borgo-valbelluna"
    }],
    "05f3903c": [{
      "hkey": "4f3e66f8",
      "slug": "villapiana-ronchena",
      "name": "Villapiana-Ronchena",
      "primary": true,
      "skipSearch": false
    }],
    "villapiana": [{
      "hkey": "4f3e66f8",
      "slug": "villapiana-ronchena",
      "name": "Villapiana-Ronchena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;